import React, { useEffect, useState } from "react";
import CertificateModal from "./CertificateModal";
const AwardCard = ({ award, index, awardMiddleIndexs }) => {
  const [awardMiddleCard, setAwardMiddleCard] = useState(false);

  useEffect(() => {
    awardMiddleIndexs.map((awardMiddleIndex) => {
      if (awardMiddleIndex === index) {
        setAwardMiddleCard(true);
      }
    });
  }, []);

  return (
    <>
      <div className="col-lg-6 col-xl-4 col-md-6 col-12">
        <div
          className={
            awardMiddleCard
              ? index === 1
                ? "eschool-award-single card-2"
                : "eschool-award-single"
              : index === 0 || index === 2
              ? "eschool-award-single card-1"
              : "eschool-award-single card-4"
          }
        >
          <div className="eschool-award-single-box">
            <div className="eschool-award-single-icon">
              <img src={award?.award_img} alt="#" />
              <span className="eschool-award-cont-date">{award?.date}</span>
            </div>
            <div className="eschool-award-content">
              <h6 className="eschool-award-cont-sm-title">
                {award?.award_title}
              </h6>
              <h4 className="eschool-award-cont-big-title">
                {award?.award_text}
              </h4>
              <span className="eschool-award-cont-location">
                <i className="fi fi-rs-marker"></i>
                {award?.location}
              </span>
            </div>
          </div>
          <div className="award-certificate">
            <CertificateModal
              galleryID={award?.id}
              images={award?.certificate}
            />
          </div>
        </div>
      </div>
      {/* <CertificateModal /> */}
    </>
  );
};

export default AwardCard;
